import MaterialTable, { MTableToolbar } from 'material-table';
import React from 'react';
import { CENTRALIZED_LOGGER_CORRELATION } from '../constants/ApiEndpoints';
import { makeGetRequest } from '../helpers/biztechAxiosRequest';
import moment from 'moment';
import loadingGif from '../assets/loading.gif';
import { Icon } from '@avalara/skylab-react';
import { DD_MMM_YYYY_HH_MM_SS_A_Z } from '../constants/DateTimeFormats';
import blueSearchIcon from '../assets/bluesearch.png';
import { withRouter } from '../containers/WithRouter';

function SearchBox(props: {
  handleKeyPress: (event: { key: string }) => void;
  correlationId: string;
  handleChange: (event: { target: { name: string; value: string } }) => void;
  getCustomerAccount: (correlationId: string) => void;
}) {
  return (
    <div className="SearchContainer">
      <div className="SearchBarArea">
        <div className="SearchBar">
          <input
            className="SearchBox"
            placeholder="Search Id ..."
            onKeyPress={props.handleKeyPress}
            value={props.correlationId}
            onChange={props.handleChange}
            type="text"
            name="correlationId"
            required
          />
          <img
            src={blueSearchIcon}
            alt="Search Icon"
            className="SearchButton"
            onClick={props.getCustomerAccount as any}
          />
        </div>
      </div>
    </div>
  );
}

class CorrelationLogTable extends React.Component<{
  router: any;
}> {
  state = {
    correlationId: '',
    logs: [],
    shownLogs: [],
    loading: false,
    errorMessage: '',
    showInfo: false
  };

  handleUrlParameter = () => {
    const correlationId = this.props?.router?.params?.id;
    if (correlationId) {
      this.setState({ correlationId: correlationId });
      this.getCorrelationLogs(correlationId);
    }
  };

  getCorrelationLogs = (correlationId: string) => {
    this.setState({ loading: true });
    const centralizedLogURL = `${CENTRALIZED_LOGGER_CORRELATION}/${correlationId}`;
    makeGetRequest(centralizedLogURL)
      .then((result: any) => {
        const filterLogs = result.data.data.customerLogs.filter(
          (log: any) => log.status !== 'Info'
        );
        this.setState({
          logs: result.data.data.customerLogs,
          shownLogs: this.formatTimeStamp(filterLogs)
        });
        this.setState({ loading: false });
      })
      .catch(error => {
        this.setState({ errorMessage: 'Sorry, something went wrong !' });
        this.setState({ loading: false });
      });
  };

  formatTimeStamp(logs: any[]): any {
    return logs.map(log => {
      return {
        ...log,
        senderTimestamp: moment(log.senderTimestamp).format(
          DD_MMM_YYYY_HH_MM_SS_A_Z
        )
      };
    });
  }

  componentDidMount() {
    this.handleUrlParameter();
  }

  infoToggleHandler = () => {
    if (this.state.showInfo) {
      const filterLogs = this.state.logs.filter(
        (log: any) => log.status !== 'Info'
      );
      this.setState({
        showInfo: false,
        shownLogs: this.formatTimeStamp(filterLogs)
      });
    } else {
      this.setState({
        showInfo: true,
        shownLogs: this.formatTimeStamp(this.state.logs)
      });
    }
  };

  handleKeyPress = (event: { key: string }) => {
    if (event.key === 'Enter') {
      window.history.replaceState(
        null,
        '',
        `/#/logs/correlation/${this.state.correlationId}`
      );
      this.getCorrelationLogs(this.state.correlationId);
    }
  };

  handleChange = (event: any) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    if (this.state.loading) {
      return (
        <div>
          {' '}
          <br />
          <br /> <br /> <img src={loadingGif} alt="Please wait" />{' '}
          <h1>processing ...</h1>{' '}
        </div>
      );
    }

    if (this.state.errorMessage) {
      return (
        <div>
          <br />
          <h1>{this.state.errorMessage}</h1>{' '}
        </div>
      );
    }
    if (!this.state.loading) {
      return (
        <>
          <h1>Centralized Log</h1>
          <SearchBox
            handleKeyPress={this.handleKeyPress}
            correlationId={this.state.correlationId}
            handleChange={this.handleChange}
            getCustomerAccount={this.getCorrelationLogs}
          />

          {this.state.shownLogs.length !== 0 && (
            <div
              id="correlationIdTable"
              style={{
                margin: '30px',
                border: '4px solid black',
                padding: '10px'
              }}
            >
              <MaterialTable
                title=""
                columns={[
                  { title: 'Id', field: 'id', hidden: true },
                  { title: 'Process', field: 'process' },
                  { title: 'Category', field: 'category' },
                  {
                    title: 'Status',
                    field: 'status'
                  },
                  { title: 'Date and Time', field: 'senderTimestamp' },
                  {
                    title: 'Performed By',
                    field: 'performedBy',
                    render: (rowData: any) => {
                      return rowData.performedBy === 'OPUS' ? (
                        <p style={{ color: '#FF6600', fontWeight: 'bold' }}>
                          {rowData.performedBy}
                        </p>
                      ) : (
                        <p style={{ color: '#059BD2', fontWeight: 'bold' }}>
                          {rowData.performedBy}
                        </p>
                      );
                    }
                  },
                  { title: 'Summary', field: 'summary', width: '25%' }
                ]}
                options={{
                  paging: false,
                  sorting: true,
                  grouping: true,
                  columnsButton: true,
                  rowStyle: (_data: any, index: number, _level: number) => {
                    if (_data.status === 'Failed')
                      return { backgroundColor: '#EA3C53' };
                    return {};
                  }
                }}
                data={this.state.shownLogs}
                components={{
                  Toolbar: props => (
                    <div>
                      <MTableToolbar {...props} />
                      <div
                        style={{
                          padding: '10px 10px',
                          backgroundColor: '#6F6F6F',
                          display: 'flex'
                        }}
                      >
                        <button
                          className="icon-trailing"
                          onClick={() => {
                            this.infoToggleHandler();
                          }}
                        >
                          {this.state.showInfo ? (
                            <>
                              Hide Info Logs <Icon name="close" />
                            </>
                          ) : (
                            <>
                              Show Info Logs <Icon name="check" />
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  )
                }}
              />
            </div>
          )}

          {this.state.shownLogs.length === 0 &&
            this.state.correlationId !== '' && (
              <div>
                <br />
                <h1>
                  No Centralized Logs Found for correlationId:{' '}
                  {this.state.correlationId}
                </h1>{' '}
              </div>
            )}

          {this.state.correlationId === '' && (
            <div>
              <h3>
                Please enter correlation Id to search logs
                {this.state.correlationId}
              </h3>
            </div>
          )}
        </>
      );
    }
  }
}

export default withRouter(CorrelationLogTable);
